import * as isotope from "./plugins/isotope.js";
import "./plugins/jquery-mousewheel.js";

import * as mfp from "./plugins/mfp.js";
import * as accordion from "./plugins/accordion.js";
//import * as lazyload from "./plugins/lazyload.js";
//import * as masonry from "./plugins/masonry.js";
import * as vscroll from "./plugins/vscroll.js";

export function init() {
  mfp.init();
  //masonry.init();
  //lazyload.init();

  init_carousel();
  init_isotope();
}

function init_carousel() {
  //slick.init();
}

export function init_isotope() {
  console.log("init isotope");
  isotope.init();
}
